export const deaccessionInitialValue = {
  catalogue: {
    museum_id: null,
    date_of_aquisition: '',
    date_of_entry: '',
    dimensions: [
      {
        translations: {
          en: {
            name: 'Height',
            description: 'Height of the object'
          }
        },
        value: null
      },
      {
        translations: {
          en: {
            name: 'Weight',
            description: 'This is the kg'
          }
        },
        value: null
      },
      {
        translations: {
          en: {
            name: 'Width',
            description: 'This is the cm'
          }
        },
        value: null
      },
      {
        translations: {
          en: {
            name: 'Length',
            description: 'This is the cm'
          }
        },
        value: null
      }
    ],
    attachment_ids: [],
    accession_no: '',
    ownership: '',
    classification: '',
    object_type: '',
    object_name: '',
    sub_group: '',
    material: '',
    dyes: '',
    motifs: '',
    description: '',
    condition: '',
    location: '',
    place_of_origin: '',
    exhibition_history: '',
    other_info: ''
  }
};